
    <div class="d-flex d-flex-gap-2x flex-column">
      <div fieldmagicGridRow>
        <div
          fieldmagicGridColumn="12"
          class="d-flex d-flex-gap justify-content-end"
        >
          <fieldmagic-primary-button
            label="Add Variant"
            [icon]="[
              {
                icon: 'plus-circle',
                klass: 'text-success'
              }
            ]"
            purpose="icon"
            (click)="onAdd()"
          >
          </fieldmagic-primary-button>
          <fieldmagic-primary-button
            purpose="ai"
            [isInProgress]="generating$ | async"
            (click)="onGenerate()"
          >
          </fieldmagic-primary-button>
        </div>
      </div>

      <div fieldmagicGridRow>
        <div fieldmagicGridColumn="12">
          <table class="table table-bordered">
            <thead>
              <tr>
                <td width="40%">
                  <fieldmagic-text
                    content="Variant"
                    purpose="table-header"
                    [withRequiredMarker]="true"
                  >
                  </fieldmagic-text>
                </td>
                <td width="35%">
                  <fieldmagic-text
                    content="Description"
                    purpose="table-header"
                  >
                  </fieldmagic-text>
                </td>
                <td width="25%">
                  <fieldmagic-text
                    content="Linked Product"
                    purpose="table-header"
                  >
                  </fieldmagic-text>
                </td>
                <td width="5%"></td>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngIf="fetching$ | async">
                <tr class="text-center">
                  <td colspan="3">
                    <fieldmagic-icon [spin]="true"></fieldmagic-icon>
                  </td>
                </tr>
              </ng-container>

              <ng-container *ngIf="! (fetching$ | async)">
                <ng-container *ngIf="variants$ | async as variants">
                  <tr
                    *ngIf="isEmpty"
                    class="text-center"
                  >
                    <td colspan="3">{{ 'No variants available.' | translate }}</td>
                  </tr>

                  <ng-container *ngFor="let variant of variants; let variant_index = index; trackBy: tracker">
                    <ng-container *ngIf="! variant.deleted">
                      <tr>
                        <td>
                          <div class="d-flex d-flex-gap align-items-center">
                            <fieldmagic-primary-button
                              purpose="add-line"
                              (click)="onAddSubVariant(variant_index)"
                              tooltip="Click to add sub variant"
                            >
                            </fieldmagic-primary-button>

                            <fieldmagic-text-input
                              placeholder="Variant Name.."
                              [standalone]="true"
                              [(ngModel)]="variant.name"
                              [errors]="errors | data_get: ('%s:name' | sprintf: [variant.id])"
                              (ngModelChange)="onVariantChange(variant_index)"
                              class="w-100"
                            >
                            </fieldmagic-text-input>
                          </div>
                        </td>
                        <td>
                          <fieldmagic-textarea-input
                            [expandable]="true"
                            placeholder="Description..."
                            [standalone]="true"
                            [(ngModel)]="variant.description"
                            [errors]="errors | data_get: ('%s:description' | sprintf: [variant.id])"
                            (ngModelChange)="onVariantChange(variant_index)"
                          >
                          </fieldmagic-textarea-input>
                        </td>
                        <td>
                          <fieldmagic-relate-input
                            placeholder="Please select a product linked to this variant.."
                            [(ngModel)]="variant.item_id"
                            moduleName="items"
                            [filter]="{
                              active: true,
                              labor: false
                            }"
                            (ngModelChange)="onVariantChange(variant_index)"
                          >
                          </fieldmagic-relate-input>
                        </td>
                        <td>
                          <div class="d-flex d-flex-gap">
                            <fieldmagic-primary-button
                              *ngIf="isLast(variant)"
                              purpose="add-line"
                              (click)="onAdd()"
                              tooltip="Click to add variant"
                            >
                            </fieldmagic-primary-button>

                            <fieldmagic-primary-button
                              purpose="delete-icon"
                              (click)="onRemove(variant_index)"
                              tooltip="Click to remove variant"
                            >
                            </fieldmagic-primary-button>
                          </div>
                        </td>
                      </tr>

                      <ng-container *ngIf="variant.sub_variants | filled">
                        <ng-container *ngFor="let sub_variant of variant.sub_variants; let sub_variant_index = index; trackBy: tracker">
                          <tr *ngIf="! sub_variant.deleted">
                            <td>
                              <fieldmagic-indent>
                                <fieldmagic-text-input
                                  placeholder="Variant Name.."
                                  [standalone]="true"
                                  [(ngModel)]="sub_variant.name"
                                  [errors]="errors | data_get: ('%s:%s:name' | sprintf: [variant.id, sub_variant.id])"
                                  (ngModelChange)="onVariantChange(variant_index)"
                                  class="w-100"
                                >
                                </fieldmagic-text-input>
                              </fieldmagic-indent>
                            </td>
                            <td>
                              <fieldmagic-textarea-input
                                [expandable]="true"
                                placeholder="Description..."
                                [standalone]="true"
                                [(ngModel)]="sub_variant.description"
                                [errors]="errors | data_get: ('%s:%s:description' | sprintf: [variant.id, sub_variant.id])"
                                (ngModelChange)="onVariantChange(variant_index)"
                              >
                              </fieldmagic-textarea-input>
                            </td>
                            <td>
                              <fieldmagic-relate-input
                                placeholder="Please select a product linked to this variant.."
                                [(ngModel)]="sub_variant.item_id"
                                moduleName="items"
                                [filter]="{
                                  active: true,
                                  labor: false
                                }"
                                (ngModelChange)="onVariantChange(variant_index)"
                              >
                              </fieldmagic-relate-input>
                            </td>
                            <td>
                              <fieldmagic-primary-button
                                purpose="delete-icon"
                                tooltip="Click to remove sub variant"
                                (click)="onSubVariantRemove(variant_index, sub_variant_index)"
                              >
                              </fieldmagic-primary-button>
                            </td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  